export const V_LOADING_ROOM = "LOADING_ROOM";
export const V_NICKNAME_IS_TAKEN = "NICKNAME_IS_TAKEN";
export const V_ROOM_NOT_FOUND = "ROOM_NOT_FOUND";
export const V_WAITING = "WAITING";
export const V_QUESTION = "QUESTION";
export const V_FINAL = "FINAL";
